module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-4"
  }, [_c('h2', [_c('trans', {
    attrs: {
      "msg": "step4_title"
    }
  })], 1), _vm._v(" "), _c('p', [_c('trans', {
    attrs: {
      "msg": "step4_description"
    }
  })], 1), _vm._v(" "), _c('label', [_c('trans', {
    attrs: {
      "msg": "step4_label"
    }
  })], 1), _vm._v(" "), _c('button', {
    class: {
      active: _vm.currency === 'EUR', inactive: _vm.currency && _vm.currency != 'EUR'
    },
    attrs: {
      "value": "EUR"
    },
    on: {
      "click": _vm.change_value
    }
  }, [_vm._v("€")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.currency === 'USD', inactive: _vm.currency && _vm.currency !== 'USD'
    },
    attrs: {
      "value": "USD"
    },
    on: {
      "click": _vm.change_value
    }
  }, [_vm._v("$")]), _vm._v(" "), (_vm.invalid.indexOf('currency') != -1) ? _c('label', {
    staticClass: "form-error"
  }, [_c('trans', {
    attrs: {
      "msg": "step4_error"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9556372"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Step4.vue
// module id = 73
// module chunks = 0